import { InspectionConclusionEnum } from "commons/enum/inspection";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBaseProperties } from "../../base";
import { Product } from "../../products/product";
export const StellaInspectionNoteItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      appearance: types.maybeNull(types.string),
      amount: types.maybeNull(types.string),
      appearanceResult: types.maybeNull(types.string),
      appearanceConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "appearanceConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      widthResult: types.maybeNull(types.number),
      widthConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "widthConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      lengthResult: types.maybeNull(types.number),
      lengthConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "lengthConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      heightResult: types.maybeNull(types.number),
      heightConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "heightConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      quantificationResult: types.maybeNull(types.number),
      quantificationConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "quantificationConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      foilResult: types.maybeNull(types.number),
      foilConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "foilConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      printPaperSPUnit: types.maybeNull(types.string),
      foldingStandardSizeConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "foldingStandardSizeConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      foldingStandardSizeResult: types.maybeNull(types.string),
      foldingStandardCountConclusion: types.maybeNull(
        types.enumeration<InspectionConclusionEnum>(
          "foldingStandardCountConclusion",
          Object.values(InspectionConclusionEnum),
        ),
      ), //Enum: Passed or Failed
      foldingStandardCountResult: types.maybeNull(types.string),
    }),
  )
  .actions(withSetPropAction);
export interface IStellaInspectionNoteItem extends Instance<
  typeof StellaInspectionNoteItem
> {}
export interface IStellaInspectionNoteItemProperties extends SnapshotIn<
  typeof StellaInspectionNoteItem
> {}

export interface ExtraPropertiesForDisplay {
  length?: number;
  height?: number;
  width?: number;
  quantification?: string;
  foil?: string;
  printPaperSP?: number;
  foldingStandardSize?: string;
  foldingStandardCount?: string;
}

export interface IAddStellaInspectionNoteItem
  extends
    ExtraPropertiesForDisplay,
    Omit<
      IStellaInspectionNoteItemProperties,
      "product" | keyof IBaseProperties
    > {}
export interface IUpdateStellaInspectionNoteItem
  extends
    ExtraPropertiesForDisplay,
    Omit<IStellaInspectionNoteItemProperties, "product"> {}
